import { TenantEntity } from '@/class/model/TenantEntity'

/**
 * 发票号管理-购买记录
 */
export class PurchaseInvoiceRecords extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get invoiceType() {
    return this._data.invoiceType
  }
  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType
  }
  get startInvoiceNo() {
    return this._data.startInvoiceNo
  }
  set startInvoiceNo(startInvoiceNo) {
    this._data.startInvoiceNo = startInvoiceNo
  }
  get endInvoiceNo() {
    return this._data.endInvoiceNo
  }
  set endInvoiceNo(endInvoiceNo) {
    this._data.endInvoiceNo = endInvoiceNo
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get purchaser() {
    return this._data.purchaser
  }
  set purchaser(purchaser) {
    this._data.purchaser = purchaser
  }
  get purchasingDate() {
    return this._data.purchasingDate
  }
  set purchasingDate(purchasingDate) {
    this._data.purchasingDate = purchasingDate
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
}
